import { render, staticRenderFns } from "./PayrollWizard.vue?vue&type=template&id=32841fe0"
import script from "./PayrollWizard.vue?vue&type=script&lang=js"
export * from "./PayrollWizard.vue?vue&type=script&lang=js"
import style0 from "./PayrollWizard.vue?vue&type=style&index=0&id=32841fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports